export const enum Endpoints {
    CONFIRM_QUOTE_C2F = '/v1/sell/confirm',
    CONFIRM_QUOTE_F2C = '/v1/buy/confirm',
    CURRENCY_PAIRS = '/v1/system/currency-pairs',
    LOGIN = '/v1/user/login',
    LOGIN_TOKEN = '/v1/user/login-token',
    ORDER_STATUS_F2C = '/v1/user/buy/orders/{id}',
    PAYMENT_METHODS = '/v2/buy/payment-methods',
    PRICES = '/v1/prices',
    QUOTE_F2C = '/v1/buy/quote',
    QUOTE_C2F = '/v1/sell/quote',
    BUY_ORDERS = '/v1/user/buy/orders',
    SELL_ORDERS = '/v1/user/sell/orders',
    REFRESH_TOKEN = '/v1/refresh',
    REGISTER_IDENTIFIER = '/v1/user/register-identifier',
    SYSTEM_INFO = '/v1/system/info',
    TRANSACTION_INFO = '/v1/user/sell/orders/{id}/transaction-info',
    USER_INFO = '/v1/user/info',
    VERIFY_AMLD5 = '/v1/user/verify/amld5',
    TRANSLATIONS = '/v1/translate',
    CREATE_DCA_CODE = '/v1/user/dca-code',
    WALLET_ADDRESS_VERIFICATION = '/v1/user/verify/wallet-address',

    // V2
    CLIENT_INFO = '/v2/client/info',
    CONFIRM_QUOTE_F2C_UCO = '/v2/buy/confirm',
    GET_DCA_CODES = '/v2/user/dca-codes',
    OFFER_UUID = '/v2/buy/offer',
    PAYMENT_SESSION = '/v2/orders/{id}/payment-session',
    PAYMENT_STATUS = '/v2/orders/{id}/payment-status?redirectResult={redirectResult}',
    PAYMENT_STATUS_SUBMIT = '/v2/orders/{orderId}/payment-status',
    VALIDATE_LIMIT = '/v2/orders/{id}/validate-limits',
    SIGNUP = '/v2/user',
    LOGIN_WITH_TOKEN = '/v2/user/login-with-token',
    USER_STATUS = '/v2/user/verification-status',
    USER_LIMITS = '/v2/user/limit',

    //CM
    CM_PAYMENT_CARDS = "/v2/orders/{id}/cm/cards",
    CM_IDEAL = "/v2/orders/{id}/cm/ideal",
    CM_PAYMENT_CARDS_BANCONTACT = "/v2/orders/{id}/cm/bancontact/card",

    // Worldpay
    WORLD_PAY_PAYMENT_CARDS = '/v2/orders/{id}/worldpay/cards',
    WORLD_PAY_PAYMENT_CARDS_DDC = '/v2/orders/worldpay/cards/ddc',
    WORLD_PAY_PAYMENT_CARDS_DDC_SUBMIT = '/v2/orders/{id}/worldpay/cards/ddc/submit',
    WORLD_PAY_PAYMENT_CARDS_CHALLENGE = '/v2/orders/worldpay/cards/challenge',
    WORLD_PAY_PAYMENT_CARDS_CHALLENGE_FINALIZE = '/v2/orders/{id}/worldpay/cards/challenge/finalize',

    // Apple pay
    APPLE_PAY_VALIDATE = "/v2/orders/{id}/apple-pay/validate",
    APPLE_PAY_AUTHORIZE = "/v2/orders/{id}/apple-pay/authorize",

    // Proxy
    LEDGER_PREPARE_SELL = '/ledger/sell/prepare',
    LEDGER_SELL_ORDER = '/ledger/sell/order',
    LEDGER_SELL_TX = '/ledger/sell/{id}/txid',
    LEDGER_MAPPED_ASSETS = '/ledger/assets'
}
